import { render, staticRenderFns } from "./landing-light.vue?vue&type=template&id=3d9ac2e1&scoped=true&lang=pug&"
import script from "./landing-light.vue?vue&type=script&lang=js&"
export * from "./landing-light.vue?vue&type=script&lang=js&"
import style0 from "./landing-light.vue?vue&type=style&index=0&id=3d9ac2e1&prod&lang=scss&"
import style1 from "./landing-light.vue?vue&type=style&index=1&id=3d9ac2e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ac2e1",
  null
  
)

export default component.exports